import React, { useEffect } from "react";
import { formatStakeBalance, getPackageIcon } from "./stakingStakeHelpers";
import "./staking.css";

const RedeemSuccessPopup = ({
  selectedPackage,
  redeemAmount,
  currency,
  timeReceived,
  onDone,
}) => {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onDone?.();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onDone]);

  if (!selectedPackage) return null;

  const currencyFullName = selectedPackage.currencyFullName || selectedPackage.fullName || "";

  return (
    <div className="stake-success-overlay" onClick={onDone}>
      <div className="stake-success-content" onClick={(e) => e.stopPropagation()}>
        <div className="stake-success-icon" aria-hidden="true">
          <i className="ri-checkbox-circle-fill" />
        </div>
        <h3 className="stake-success-title">Redemption Successful!</h3>
        <p className="stake-success-message">
          Your redemption request for{" "}
          <strong>{formatStakeBalance(redeemAmount)} {currency}</strong> has been submitted successfully.
        </p>

        <div className="stake-success-package">
          <img
            src={getPackageIcon(selectedPackage)}
            alt={currency}
            className="stake-success-package__icon"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = `/images/staking_img/${String(currency || "usdt").toLowerCase()}_icon.svg`;
            }}
          />
          <div className="stake-success-package__info">
            <span className="stake-success-package__name">
              {currency}
              {currencyFullName ? ` (${currencyFullName})` : ""}
            </span>
            <span className="stake-success-package__meta">
              Expected received: {timeReceived}
            </span>
          </div>
        </div>

        <button type="button" className="mint-btn-confirm stake-success-btn" onClick={onDone}>
          Done
        </button>
      </div>
    </div>
  );
};

export default RedeemSuccessPopup;
